<script>
import { Doughnut } from 'vue-chartjs';

export default {
  name: 'SimplePieChart',
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartdata: {
      handler(value) {
        if (value) {
          this.renderChart(this.chartdata, this.options);
        }
      },
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
